import z from "zod";
import { MetaSchema } from "./shared";

export const CampaignSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  startDate: z.string().datetime().or(z.string()),
  endDate: z.string().datetime().or(z.string()),
  status: z.string(),
  executionType: z.string(),
  createdAt: z.string().datetime().or(z.string()),
});

export type CampaignItem = z.infer<typeof CampaignSchema>;

const Campaign = z.object({
  data: z.array(CampaignSchema),
  meta: MetaSchema.default,
});

export type Campaign = z.infer<typeof Campaign>;

export default Campaign;